module.exports = __webpack_public_path__ + "media/images/logo_note_w_trans-6b4d91346222811661a6243ee09390c4.png";